import React from "react";
import EcommerceB2B from "./ecommerce/EcommerceB2B";

function B2B() {
  return (
    <EcommerceB2B />
  );
}

export default B2B;
